module.exports = __webpack_public_path__ + "img/oracle.b55130cd.png";